import angular from "angular";

angular
    .module('app')
    .component('socialLinksForm', {
        template: require('./social-links-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.type = null;
    $ctrl.icon = null;
    $ctrl.link = null;
    $ctrl.types = null;
    $ctrl.validationErrors = [];

    $ctrl.$onInit = function () {

        $ctrl.socLink = $ctrl.resolve.socLink;

        $ctrl.types = [
            {
                'key': 'Telegram',
                'value': 'tel'
            },
            {
                'key': 'Youtube',
                'value': 'yb'
            },
            {
                'key': 'Instagram',
                'value': 'in'
            },
            {
                'key': 'What`s App',
                'value': 'wh'
            },
            {
                'key': 'Facebook',
                'value': 'fb'
            }
        ];

        if ($ctrl.socLink) {
            $ctrl.id = $ctrl.socLink.id;
            $ctrl.icon = $ctrl.socLink.icon;
            $ctrl.link = $ctrl.socLink.link;

            angular.forEach($ctrl.types, function(type) {
                if (type.value === $ctrl.socLink.type) {
                    $ctrl.type = type;
                }
            });
        }


    };

    $ctrl.save = function () {

        let req = null;
        $ctrl.loading = true;


        let params = {
            type: $ctrl.type.value,
            link: $ctrl.link
        };
        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/social-links/${$ctrl.id}`, params);
        } else {
            req = $http.post('/admin/social-links', params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Ссылка успешно создана', 2);
                } else {
                    Notifier.success('Ссылка успешно обновлена', 2);
                }

                $ctrl.icon = response.data.icon;

                $ctrl.close({
                    $value: {
                        id: $ctrl.id,
                        icon: $ctrl.icon,
                        type: $ctrl.type.value,
                        link: $ctrl.link
                    }
                });

            },
            function (error) {
                $ctrl.loading = false;

                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error('Ошибка при заполнении', 2);
                } else {
                    Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                }
            }
        );
    };


}
